// import { applyMiddleware, createStore, Dispatch } from 'redux';
// import thunkMiddleware from 'redux-thunk';
// import rootReducer from '../reducers';
// // import { fetchProvinces, IStateProvince } from '../actions';

// /**
//  * 应用中所有的 state 都以一个对象树的形式储存在一个单一的 store 中。
//  * 惟一改变 state 的办法是触发 action，一个描述发生什么的对象。
//  * 为了描述 action 如何改变 state 树，你需要编写 reducers。
//  *
//  * thunkMiddleware：处理异步Action
//  */
// const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));

// // StoreConfig().dispatch<any>(fetchProvinces());
// export default store;

import { persistStore, persistCombineReducers } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';
const config = {
  key: 'root',
  // storage,
  storage: storageSession,
  blacklist: ['taskState', 'webSocketState', 'mallBrandState'],
};

const reducer = persistCombineReducers(config, rootReducer);

// const rootReducer2 = (state: any, action: IStateAuth) => {
//   if (action.type === LOGOUT_SUCCESS) {
//     state = undefined;
//   }
//   return reducer(state, action);
// };
// const devMiddleware = composeWithDevTools(applyMiddleware(thunkMiddleware));
export const store = createStore(reducer, applyMiddleware(thunkMiddleware));
export const persistor = persistStore(store);

// const rootReducer = (state: IStoreState | undefined, action: IStateAuth) => {
//   if (action.type === LOGOUT_SUCCESS) {
//     state = undefined;
//   }
//   return appReducer(state, action);
// };

// export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/store/index.ts